module.exports = __webpack_public_path__ + "img/10.70b73cfd.png";